/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linearly with volume — since the concentration is fixed, each ingredient is simply proportional to how much buffer you make.`)
};

const es_buf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De forma lineal con el volumen — como la concentración es fija, cada ingrediente es simplemente proporcional a la cantidad de buffer que prepares.`)
};

const de_buf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linear mit dem Volumen — da die Konzentration fest ist, ist jede Zutat einfach proportional zur hergestellten Puffermenge.`)
};

const nl_buf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lineair met het volume — omdat de concentratie vast is, is elk ingrediënt simpelweg evenredig met de hoeveelheid buffer die u maakt.`)
};

const fr_buf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linéairement avec le volume — la concentration étant fixe, chaque ingrédient est simplement proportionnel à la quantité de tampon préparée.`)
};

const it_buf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linearmente con il volume — poiché la concentrazione è fissa, ogni ingrediente è semplicemente proporzionale alla quantità di buffer preparata.`)
};

const pt_br2_buf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linearmente com o volume — como a concentração é fixa, cada ingrediente é simplesmente proporcional à quantidade de tampão que você prepara.`)
};

const pt_buf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linearmente com o volume — como a concentração é fixa, cada ingrediente é simplesmente proporcional à quantidade de tampão preparada.`)
};

const ja_buf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`量に比例して直線的にスケーリングされます。濃度が固定されているため、各試薬量は調製するバッファーの量に単純に比例します。`)
};

const zh_buf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按体积线性放大——由于浓度固定，每种成分的用量与配制的缓冲液总量成正比。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_faq_a1", locale)
	if (locale === "en") return en_buf_faq_a1(inputs)
	if (locale === "es") return es_buf_faq_a1(inputs)
	if (locale === "de") return de_buf_faq_a1(inputs)
	if (locale === "nl") return nl_buf_faq_a1(inputs)
	if (locale === "fr") return fr_buf_faq_a1(inputs)
	if (locale === "it") return it_buf_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_buf_faq_a1(inputs)
	if (locale === "pt") return pt_buf_faq_a1(inputs)
	if (locale === "ja") return ja_buf_faq_a1(inputs)
	return zh_buf_faq_a1(inputs)
};